<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <clientsidebar></clientsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <div v-if="hasTPPermission===true">
              <div v-if="wtdata!==null">
                <div class="row">
                   <div class="col-12 text-right">
                       <input type="checkbox" v-model="archived" @change="renderTrainingPlans(true)" /> Show Archived
                   </div>
                </div>
                <wondertable :wtID="'myTrainingPlans'" :tcapiData="wtdata" :methods="wtmethods" :noRecords="'You Have No Training Plans'" :defaultDirection="0"
                             :ids="wids" :hasExportExcel="'1'" :hasExportPDF="'1'" :title="'Training Plans'" :burgerMenu="burgermenu" ref="wtRef" ></wondertable>
              </div>
            </div>
            <div v-if="hasTPPermission===false">
              <div class="row">
                <div class="col-12" id="your_account_does_not_have_access_to_training_plans">
                  Your account does not have access to Training Plans. Please contact SIMmersion to gain access to this area of Admin Center.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  
  </div>
</template>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientsidebar from "../../layout/Client/Sidebar.vue"
  import wondertable from "../../components/WonderTable.vue"

  export default {
    name: 'CliTrainingPlans',
    components:{acheader,acfooter,clientsidebar,wondertable},
    data() {
      return {

        archived:false,
        burgermenu:[[{html:"Add", value:"doAdd"}]],
        hasTPPermission: false,
        CurriculumID:null,       
        wids: ["CurriculaID"],
        wtdata: null,
        wtmethods: {
          doAdd: {
            method: function(param, ref) {
              ref.doAdd(param);
            },
            ref: this
          },
          doUsers: {
            method: function(param, ref) {
              ref.doUsers(param);
            },
            ref: this
          },
          doPools: {
            method: function(param, ref) {
              ref.doPools(param);
            },
            ref: this
          },
          doEditors: {
            method: function(param, ref) {
              ref.doEditors(param);
            },
            ref: this
          },
          doDuplicate: {
            method: function(param, ref) {
              ref.doDuplicate(param);
            },
            ref: this
          },
          doEdit: {
            method: function(param, ref) {
              ref.doEdit(param);
            },
            ref: this
          },
          doDelete: {
            method: function(param, ref) {
              ref.doDelete(param);
            },
            ref: this
          }
        }
      }
    },
    computed: {
      isArchived: function() {
        return this.archived?"true":"false";
      }
    },
    methods: {
   
      doAdd(params) {
        this.$router.push("/trainingplans/"+this.emptyguid+"/edit");
      },
      doDelete(params) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to delete this training plan?  This action cannot be undone!', {
          title: 'Confirm Deletion',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
             {
               Operation: "LicensePool",
               Function: "DeleteCurriculum",
               Fields: {
                 LicensePoolCurriculaID: params.CurriculaID
               }
             }
            ]).then(r=>{
              this.popDialog(0, "The training plan was deleted successfully");
              this.renderTrainingPlans(true);
            })
          }
        });
      },
      doDuplicate(params) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to duplicate this training plan?', {
          title: 'Confirm Duplication',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
             {
               Operation: "LicensePool",
               Function: "DuplicateCurriculum",
               Fields: {
                 LicensePoolCurriculaID: params.CurriculaID
               }
             }
            ]).then(r=>{
              this.popDialog(0, "The training plan was duplicated successfully");
              this.renderTrainingPlans(true);
            })
          }
        });
      },
    
      doEdit(params) {
          this.$router.push("/trainingplans/"+params.CurriculaID+"/edit");
      },
     
      renderTrainingPlans(force) {
        this.apiCommand(
        [
             {
               Operation: "LicensePool",
               Function: "GetCurriculaOwned",
               Fields: {
                  IsArchived: this.isArchived
               }
             }
           
        ]).then(response=> {

          var cr = JSON.parse(response.CommandResult);

          if (force) {
            this.wtdata = JSON.parse(cr.returnObjects[0].returnObject);
            this.$refs["wtRef"].renderTable(JSON.parse(cr.returnObjects[0].returnObject));
          }
          else {
            this.wtdata = JSON.parse(cr.returnObjects[0].returnObject);
          }

        });

      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapClient(this.$route.params.id);
        if (this.sdata.ispro || this.sdata.isemployee) {
          this.hasTPPermission=true;
          this.renderTrainingPlans(false);
        }

       
      });
    }
  }
</script>
